export const StringSizeFormatter = (s: string, maxLenght: number = 20) => {
  if (s.length > maxLenght) {
    return s.substring(0, maxLenght + 1).concat('...')
  }

  return s
}
